import { render, staticRenderFns } from "./customdialog.vue?vue&type=template&id=6d15c8ee&scoped=true&"
import script from "./customdialog.vue?vue&type=script&lang=js&"
export * from "./customdialog.vue?vue&type=script&lang=js&"
import style0 from "./customdialog.vue?vue&type=style&index=0&id=6d15c8ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d15c8ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d15c8ee')) {
      api.createRecord('6d15c8ee', component.options)
    } else {
      api.reload('6d15c8ee', component.options)
    }
    module.hot.accept("./customdialog.vue?vue&type=template&id=6d15c8ee&scoped=true&", function () {
      api.rerender('6d15c8ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customdialog.vue"
export default component.exports